import _t from 'i18n!nls/account-profile';

export const ACCOUNT_PROFILE_PATH = '/account-profile';

// Swap "Other" to third entry in the UI while keeping its enum value as the fourth one
const getGender = () => [
  {
    id: 1,
    value: _t('Female'),
  },
  {
    id: 2,
    value: _t('Male'),
  },
  {
    id: 4,
    value: _t('Other'),
  },
  {
    id: 3,
    value: _t("I'd rather not say"),
  },
];

// Enum values start at 1
const getMonths = () => [
  _t('January'),
  _t('February'),
  _t('March'),
  _t('April'),
  _t('May'),
  _t('June'),
  _t('July'),
  _t('August'),
  _t('September'),
  _t('October'),
  _t('November'),
  _t('December'),
];

const days: any = Array.from({ length: 31 }, (v, k) => k + 1);

const currentYear = new Date().getFullYear();
const earliestYear = 1900;
const ageLimit = 13;
const years: any = Array.from(
  { length: currentYear - ageLimit - earliestYear + 1 },
  (v, k) => currentYear - ageLimit - k
);

// Enum values start at 1
// NOTE: ID values mirrored for onboarding use - static/bundles/onboarding-2021/data/constants.ts
const getEmploymentStatus = () => [
  { id: 1, value: _t('Employed full time (35 or more hours per week)') },
  { id: 2, value: _t('Employed part time (less than 35 hours per week)') },
  { id: 3, value: _t('Self-employed full time (35 or more hours per week)') },
  { id: 4, value: _t('Self-employed part time (less than 35 hours per week)') },
  { id: 5, value: _t('Homemaker, taking care of a family member, or on maternity/paternity leave') },
  { id: 6, value: _t('Unemployed and looking for work') },
  { id: 7, value: _t('Unemployed and not looking for work') },
  { id: 8, value: _t('Retired') },
  { id: 9, value: _t('Unable to work') },
];

// Enum values start at 1
const getStudentStatus = () => [
  _t('Full-time student in a degree-granting educational program'),
  _t('Part-time student in a degree-granting educational program'),
  _t('I am not currently a student in a degree-granting educational program'),
];

// Enum values start at 1
const getWorkExperience = (): { id: number; value: string }[] => [
  {
    id: 1,
    value: _t('Intern / Trainee'),
  },
  {
    id: 2,
    value: _t('Junior / Entry-level (0-2 years experience)'),
  },
  {
    id: 3,
    value: _t('Mid-level (2+ years experience)'),
  },
  {
    id: 4,
    value: _t('Lead / Manager'),
  },
  {
    id: 5,
    value: _t('Senior Manager / Director'),
  },
  {
    id: 6,
    value: _t('Executive'),
  },
  {
    id: 7,
    value: _t('Not Applicable'),
  },
];
const getLearningGoals = () => [
  {
    id: 'land-new-job',
    name: _t('Land my first job'),
    value: 3,
  },
  {
    id: 'change-career',
    name: _t('Switch to a different role'),
    value: 2,
  },
  {
    id: 'improve-skill',
    name: _t('Advance in my current role'),
    value: 1,
  },

  {
    id: 'explore-personal-interests',
    name: _t('Explore topics outside of work'),
    value: 4,
  },
];

// Some enum values were combined/deprecated, so there are gaps
const getEducationChoices = () => [
  {
    id: 1,
    value: _t('Less than high school diploma (or equivalent)'),
  },
  {
    id: 4,
    value: _t('High school diploma (or equivalent)'),
  },
  {
    id: 5,
    value: _t('Some college but no degree'),
  },
  {
    id: 6,
    value: _t('Associate Degree (e.g., AA, AS)'),
  },
  {
    id: 8,
    value: _t("Bachelor's degree (e.g., BA, AB, BS)"),
  },
  {
    id: 9,
    value: _t("Master's degree (e.g., MA, MS, MEng, MEd, MSW, MBA)"),
  },
  {
    id: 10,
    value: _t('Professional school degree (e.g., MD, DDS, DVM, LLB, JD)'),
  },
  {
    id: 11,
    value: _t('Doctorate degree (e.g., PhD, EdD)'),
  },
];

// Some enum values were combined/deprecated, so there are gaps
const getEducationChoicesLearnerProfileV1 = () => [
  {
    rank: 0,
    name: 'NO_DEGREE',
    value: _t('Less than high school diploma (or equivalent)'),
  },
  {
    rank: 1,
    name: 'HIGH_SCHOOL_DIPLOMA',
    value: _t('High school diploma (or equivalent)'),
  },
  {
    rank: 2,
    name: 'ASSOCIATE_DEGREE',
    value: _t('Associate Degree (e.g., AA, AS)'),
  },
  {
    rank: 3,
    name: 'BACHELOR_DEGREE',
    value: _t("Bachelor's degree (e.g., BA, AB, BS)"),
  },
  {
    rank: 4,
    name: 'MASTERS_DEGREE',
    value: _t("Master's degree (e.g., MA, MS, MEng, MEd, MSW, MBA)"),
  },
  {
    rank: 5,
    name: 'PROFESSIONAL_DEGREE',
    value: _t('Professional school degree (e.g., MD, DDS, DVM, LLB, JD)'),
  },
  {
    rank: 6,
    name: 'DOCTORATE_DEGREE',
    value: _t('Doctorate degree (e.g., PhD, EdD)'),
  },
];

const getMajorChoices = () => [
  {
    name: 'ARTS_AND_HUMANITIES',
    value: _t('Arts and Humanaties'),
  },
  {
    name: 'BIOLOGICAL_SCIENCES',
    value: _t('Biological Sciences'),
  },
  {
    name: 'BUSINESS',
    value: _t('Business'),
  },
  {
    name: 'COMPUTER_SCIENCE',
    value: _t('Computer Science'),
  },
  {
    name: 'EDUCATION',
    value: _t('Education'),
  },
  {
    name: 'ENGINEERING',
    value: _t('Engineering'),
  },
  {
    name: 'HEALTH_PROFESSIONS',
    value: _t('Health'),
  },
  {
    name: 'LEGAL_PROFESSIONS',
    value: _t('Legal'),
  },
  {
    name: 'MATHEMATICS_AND_STATISTICS',
    value: _t('Mathematics and Statistics'),
  },
  {
    name: 'NA',
    value: _t('N/A'),
  },
  {
    name: 'OTHER',
    value: _t('Other'),
  },
  {
    name: 'PHYSICAL_SCIENCES',
    value: _t('Physical Sciences'),
  },
  {
    name: 'SOCIAL_SCIENCES',
    value: _t('Social Sciences'),
  },
];

const privacyTypes = {
  ONLY_ME: 10,
  COURSERA_COMMUNITY: 100,
  EVERYONE_ON_THE_WEB: 1000,
};

const getPrivacyChoices = () => [
  {
    id: [privacyTypes.ONLY_ME],
    value: _t('Only me'),
  },
  {
    id: [privacyTypes.COURSERA_COMMUNITY],
    value: _t('The Coursera community'),
  },
  {
    id: [privacyTypes.EVERYONE_ON_THE_WEB],
    value: _t('Everyone on the web'),
  },
];

const skillTypes = {
  USER_GENERATED_SKILL: 'UserGeneratedSkill',
  USER_INTERESTED_SKILL_ID: 'UserInterestSkillId',
};

const getProductNames = () => [
  { id: 1, name: _t('Guided Projects') },
  { id: 2, name: _t('Courses') },
  { id: 3, name: _t('Specializations') },
  { id: 4, name: _t('Professional Certificates') },
  { id: 5, name: _t('MasterTrack® Certificates') },
  { id: 6, name: _t('Degrees') },
];

const getBooleanAnswers = () => [
  { id: true, name: _t('Yes') },
  { id: false, name: _t('No') },
];

const LOCAL_STORAGE_ANON_PROFILE_KEY = 'anonLearnerProfile';

export const INDUSTRY_IDS = [
  'agriculture',
  'animation',
  'architecture',
  'arts',
  'automotive',
  'aviation',
  'construction',
  'consulting',
  'consumer',
  'defense',
  'delivery',
  'dispute-resolution',
  'education',
  'energy',
  'executive',
  'fashion',
  'finance',
  'fund-raising',
  'furniture',
  'gambling',
  'government',
  'government-international-nonprofit',
  'health-medicine',
  'healthcare',
  'higher-education',
  'hospitality',
  'human-resources',
  'import-export',
  'insurance',
  'legal',
  'libraries',
  'manufacturing',
  'maritime',
  'marketing',
  'media-and-entertainment',
  'natural-resources',
  'other',
  'outsourcing',
  'public-relations',
  'real-estate',
  'retail',
  'supply-chain',
  'technology',
  'telecommunications',
] as const;

export type IndustryIDs = (typeof INDUSTRY_IDS)[number];

export type Industry = {
  name: string;
  id: IndustryIDs;
  tags: string[];
};

const getIndustries = () => {
  return [
    {
      name: _t('Agriculture'),
      id: 'agriculture',
      tags: ['cbrv1'],
    },
    { name: _t('Animation'), id: 'animation', tags: ['cbrv1'] },
    { name: _t('Architecture'), id: 'architecture', tags: ['plpv1'] },
    { name: _t('Writing and Fine Arts'), id: 'arts', tags: ['cbrv1'] },
    { name: _t('Automotive'), id: 'automotive', tags: ['cbrv1'] },
    { name: _t('Aviation'), id: 'aviation', tags: ['cbrv1'] },
    { name: _t('Construction'), id: 'construction', tags: ['cbrv1'] },
    { name: _t('Consulting'), id: 'consulting', tags: ['plpv1', 'cbrv1'] },
    { name: _t('Consumer )Goods and Services'), id: 'consumer', tags: ['cbrv1'] },
    { name: _t('Defense'), id: 'defense', tags: ['cbrv1'] },
    { name: _t('Delivery'), id: 'delivery', tags: ['cbrv1'] },
    { name: _t('Dispute Resolution'), id: 'dispute-resolution', tags: ['cbrv1'] },
    { name: _t('Education'), id: 'education', tags: ['cbrv1'] },
    { name: _t('Energy'), id: 'energy', tags: ['plpv1'] },
    { name: _t('Executive'), id: 'executive', tags: ['cbrv1'] },
    { name: _t('Fashion and Design'), id: 'fashion', tags: ['cbrv1'] },
    { name: _t('Finance'), id: 'finance', tags: ['plpv1', 'cbrv1'] },
    { name: _t('Fund Raising'), id: 'fund-raising', tags: ['cbrv1'] },
    { name: _t('Furniture'), id: 'furniture', tags: ['cbrv1'] },
    { name: _t('Gambling'), id: 'gambling', tags: ['cbrv1'] },
    { name: _t('Government'), id: 'government', tags: ['plpv1'] },
    { name: _t('Government and Nonprofit'), id: 'government-international-nonprofit', tags: ['cbrv1'] },
    { name: _t('Health and Medicine'), id: 'health-medicine', tags: ['cbrv1'] },
    {
      name: _t('Healthcare (including pharmaceuticals)'),
      id: 'healthcare',
      tags: ['plpv1'],
    },
    { name: _t('Higher Education'), id: 'higher-education', tags: ['plpv1'] },
    { name: _t('Hospitality'), id: 'hospitality', tags: ['plpv1'] },
    { name: _t('Human Resources'), id: 'human-resources', tags: ['cbrv1'] },
    { name: _t('Import Export'), id: 'import-export', tags: ['cbrv1'] },
    { name: _t('Insurance'), id: 'insurance', tags: ['cbrv1'] },
    { name: _t('Legal'), id: 'legal', tags: ['plpv1', 'cbrv1'] },
    { name: _t('Libraries'), id: 'libraries', tags: ['cbrv1'] },
    { name: _t('Manufacturing'), id: 'manufacturing', tags: ['cbrv1'] },
    { name: _t('Maritime'), id: 'maritime', tags: ['cbrv1'] },
    { name: _t('Marketing'), id: 'marketing', tags: ['cbrv1'] },
    { name: _t('Media and Entertainment'), id: 'media-and-entertainment', tags: ['plpv1'] },
    { name: _t('Natural Resources'), id: 'natural-resources', tags: ['cbrv1'] },
    { name: _t('Other'), id: 'other', tags: ['cbrv1'] },
    { name: _t('Outsourcing'), id: 'outsourcing', tags: ['cbrv1'] },
    { name: _t('Public Relations'), id: 'public-relations', tags: ['cbrv1'] },
    { name: _t('Real Estate'), id: 'real-estate', tags: ['cbrv1'] },
    { name: _t('Retail'), id: 'retail', tags: ['plpv1'] },
    { name: _t('Supply Chain'), id: 'supply-chain', tags: ['cbrv1'] },
    { name: _t('Technology'), id: 'technology', tags: ['plpv1', 'cbrv1'] },
    { name: _t('Telecommunications'), id: 'telecommunications', tags: ['cbrv1'] },
  ] as Industry[];
};

export {
  getGender,
  getMonths,
  days,
  years,
  getEmploymentStatus,
  getStudentStatus,
  getLearningGoals,
  getWorkExperience,
  getEducationChoices,
  getEducationChoicesLearnerProfileV1,
  getPrivacyChoices,
  getProductNames,
  getBooleanAnswers,
  getMajorChoices,
  getIndustries,
  privacyTypes,
  skillTypes,
  currentYear,
  earliestYear,
  LOCAL_STORAGE_ANON_PROFILE_KEY,
};
